export default {
    LOAD_BANNERPHOTOS (state, bannerphotos) {
        state.items = bannerphotos
    },
    LOAD_PHOTOS_BY_BANNER (state, bannerphotos) {
        state.imagens = bannerphotos
    }
}